import { render } from "./Lihat.vue?vue&type=template&id=863e0d7e&scoped=true"
import script from "./Lihat.vue?vue&type=script&lang=js"
export * from "./Lihat.vue?vue&type=script&lang=js"

import "./Lihat.vue?vue&type=style&index=0&id=863e0d7e&lang=scss&scoped=true"

import exportComponent from "/var/www/distan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-863e0d7e"]])

export default __exports__